<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row">
          <div
            class="col-sm-12 d-flex align-items-center justify-content-between"
          >
            <div>
              <h3 class="page-title mb-1">Chi tiết nội quy</h3>
              <ul class="breadcrumb mb-0">
                <li class="breadcrumb-item">
                  <router-link to="/">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Chi tiết nội quy</li>
              </ul>
            </div>
            <div class="btn-group">
              <button
                class="btn btn-white"
                :class="{ 'btn-primary text-white': days === 7 }"
                @click="changeDays(7)"
              >
                7d
              </button>
              <button
                class="btn btn-white"
                :class="{ 'btn-primary text-white': days === 30 }"
                @click="changeDays(30)"
              >
                30d
              </button>
              <button
                class="btn btn-white"
                :class="{ 'btn-primary text-white': days === 90 }"
                @click="changeDays(90)"
              >
                90d
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h5 class="mb-0"></h5>
          <div>
            <router-link to="/noi-quy" class="btn btn-secondary btn-sm mr-2">
              <i class="la la-arrow-left mr-1"></i> Quay lại
            </router-link>
            <router-link
              v-if="noiQuy"
              :to="`/noi-quy/sua/${noiQuy.id}`"
              class="btn btn-warning btn-sm"
            >
              <i class="la la-edit mr-1"></i> Sửa
            </router-link>
          </div>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

          <div v-else-if="noiQuy">
            <h2 class="mb-3">{{ noiQuy.ten }}</h2>

            <div class="row mb-3 text-muted border-bottom pb-3">
              <div class="col-md-4">
                <strong>Phòng ban:</strong> {{ noiQuy.tenPhongBan || "Chung" }}
              </div>
              <div class="col-md-4">
                <strong>Ngày hiệu lực:</strong>
                {{ formatDate(noiQuy.ngayHieuLuc) }}
              </div>
              <div class="col-md-4">
                <strong>Người tạo:</strong> {{ noiQuy.tenNguoiTao }}
              </div>
              <div class="col-md-4 mt-2">
                <strong>Ngày tạo:</strong> {{ formatDateTime(noiQuy.ngayTao) }}
              </div>
              <div class="col-md-4 mt-2">
                <strong>Cập nhật lần cuối:</strong>
                {{ formatDateTime(noiQuy.ngaySua) }}
              </div>
            </div>

            <h4 class="mt-4">Nội dung chi tiết:</h4>
            <div class="noi-dung-content p-2" v-html="noiQuy.noiDung"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { NoiQuyApi } from "@/services/noiQuyService";
import { useToast } from "vue-toastification";

const route = useRoute();
const toast = useToast();

const noiQuyId = ref(route.params.id);
const noiQuy = ref(null);
const loading = ref(true);
const error = ref(null);

// --- Helpers ---
const formatDate = (dateString) => {
  if (!dateString) return "Chưa cập nhật";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("vi-VN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch (e) {
    return dateString;
  }
};

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return "Chưa cập nhật";
  try {
    const date = new Date(dateTimeString);
    return date.toLocaleDateString("vi-VN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (e) {
    return dateTimeString;
  }
};

// --- Lifecycle Hook ---
onMounted(async () => {
  if (!noiQuyId.value) {
    error.value = "Không tìm thấy ID nội quy.";
    loading.value = false;
    return;
  }

  loading.value = true;
  error.value = null;
  try {
    const data = await NoiQuyApi.getById(noiQuyId.value);
    noiQuy.value = data.data;
  } catch (e) {
    error.value = "Không thể tải dữ liệu nội quy. Có thể nó đã bị xóa.";
    toast.error(error.value);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
/* Thêm style để nội dung từ v-html hiển thị đẹp hơn */
.noi-dung-content {
  line-height: 1.6;
}
.noi-dung-content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
.noi-dung-content :deep(table) {
  width: 100% !important;
  border-collapse: collapse !important;
  margin-bottom: 1rem;
}
.noi-dung-content :deep(th),
.noi-dung-content :deep(td) {
  border: 1px solid #dee2e6 !important;
  padding: 0.5rem !important;
}
.noi-dung-content :deep(thead) {
  background-color: #f8f9fa;
}
</style>
